import { IDropdownButton } from '@common/interfaces/header-menu.interface';
import {
  CONSUMER_CREDIT_ROUTE,
  CONTACT_US_ROUTE,
  HOME_ROUTE,
  INSTALLMENT_PAYMENT_ROUTE,
  OFFICES_ROUTE
} from './routes.constants';
import { IButton } from '@common/interfaces/button.interface';
import { environment } from '@environments/environment';

export const MENU_DROPDOWN: IDropdownButton[] = [
  {
    buttonLabel: 'inicio',
    icon: 'i-home',
    route: HOME_ROUTE
  },
  {
    buttonLabel: 'Crédito de Consumo',
    icon: 'i-credit',
    route: CONSUMER_CREDIT_ROUTE,
  },
  {
    buttonLabel: 'Atención al cliente',
    icon: 'i-alert-circle',
    route: CONTACT_US_ROUTE,
  },
  {
    buttonLabel: 'Sucursales',
    icon: 'i-location',
    route: OFFICES_ROUTE,
  }
];

export const CUSTOMER_SUPPORT_BUTTON: IButton =
{
  label: 'Atención al cliente',
  buttonClass: 'btn btn-tertiary',
  icon: 'icon i-alert-circle',
  route: CONTACT_US_ROUTE,
};

export const FEE_PAYMENT_BUTTON: IButton =
{
  label: 'Paga tu cuota aquí',
  buttonClass: 'btn btn-secondary padding',
  route: INSTALLMENT_PAYMENT_ROUTE
};

export const SHORTCUT_BUTTONS: IButton[] = [
  FEE_PAYMENT_BUTTON
];

export const TCV_ROUTE = environment.TCV_SITE;
